angular.module('app')
    .factory('HttpHelper', function ($http, $q, toastr) {
        var fac = {};
        var showError = function (response) {

            var title = 'Unexpected Error';
            var msg = 'An unexpected error has occured.';
            if (angular.isUndefined(response)) {
                msg = 'A response received from the web server';
                toastr.error(msg);
                return;
            }

            if (response.status === 404) {
                msg = ['Could not find ', response.config.url].join('');
                toastr.error(msg);
                return;
            }

            if (response.status === 500) {
                msg = [response.data.ExceptionMessage, ' when calling ', response.config.url].join('');
                toastr.error(msg);
                return;
            }

            if (response.data) {
                title = response.data.ExceptionMessage;
                var stackTrace = response.data.StackTrace;
                msg = stackTrace.substring(stackTrace.length - 100, 100);
                toastr.error(msg, title);
                return;
            }

            toastr.error(msg, title);
        };

        // NOTE: Try a timeout of 20s for now
        var config = {
            timeout: 20000
        };

        fac.get = function (url, callerHandlesError) {
            return $http.get(url, config).then(function (response) {
                return response;
            }, function (response) {
                if (callerHandlesError) { return; }
                showError(response);
            }, function (response) {
                if (callerHandlesError) { return; }
                showError(response);
            });
        };

        // When sending a request to another origin this is helpful as the browser will not send a pre-flight OPTIONS request for a GET
        // as long as theres no custom headers in the request
        fac.getWithoutCustomHeaders = function (url, callerHandlesError) {
            var cleanHeadersConfig = {
                headers: {
                    // Only custom header we have. This list will need to be updated if any more are added
                    'X-XSRF-Token': undefined
                }
            };
            _.assign(cleanHeadersConfig, config);

            return $http.get(url, cleanHeadersConfig).then(function (response) {
                return response;
            }, function (response) {
                if (callerHandlesError) { return; }
                showError(response);
            }, function (response) {
                if (callerHandlesError) { return; }
                showError(response);
            });
        };

        fac.getNoCache = function (url, callerHandlesError) {
            return $http.get(url, { cache: false }).then(function (response) {
                return response;
            }, function (response) {
                if (callerHandlesError) { return; }
                showError(response);
            }, function (response) {
                if (callerHandlesError) { return; }
                showError(response);
            });
        };

        fac.post = function (url, data, callerHandlesError) {
            return $http.post(url, data, config).then(function (response) {
                return response;
            }, function (response) {
                if (callerHandlesError) { return; }
                showError(response);
            });
        };
        return fac;
    });
